import { render, staticRenderFns } from "./AvsList.vue?vue&type=template&id=588a436c&"
import script from "./AvsList.vue?vue&type=script&lang=js&"
export * from "./AvsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports